import React from 'react';

import { TableContainer, Table, Thead, Tr, Th, Tbody } from '@ecoinvent/ui';

import LciResultRow from './LciResultRow';
import { FilteredExchange } from './types';

type Props = { exchanges: FilteredExchange[] };

const LciResultTable = ({ exchanges }: Props) => {
  return (
    <TableContainer maxHeight={'600px'} height={'100%'} overflowY={'auto'} whiteSpace={'break-spaces'}>
      <Table size={'sm'}>
        <Thead>
          <Tr>
            <Th pl={0}>Exchange Name</Th>
            <Th>Compartment</Th>
            <Th>Amount</Th>
          </Tr>
        </Thead>
        <Tbody>
          {exchanges.map((item, index) => {
            const key = `${item.originalName}-${item.compartment}-${item.sub_compartment}`;
            return <LciResultRow item={item} key={key} tourTarget={index === 0 ? 'lci-amount' : undefined} />;
          })}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default LciResultTable;
